var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 1h-12a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V7a6 6 0 0 0-6-6Z",
    stroke: "#00412F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 17.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM19.417 6.25v.001",
    stroke: "#00412F"
  })));
};

export { SvgInstagram as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjY2NyAxSDYuNjY2OTlDMy4zNTMyOCAxIDAuNjY2OTkyIDMuNjg2MjkgMC42NjY5OTIgN1YxOUMwLjY2Njk5MiAyMi4zMTM3IDMuMzUzMjggMjUgNi42NjY5OSAyNUgxOC42NjdDMjEuOTgwNyAyNSAyNC42NjcgMjIuMzEzNyAyNC42NjcgMTlWN0MyNC42NjcgMy42ODYyOSAyMS45ODA3IDEgMTguNjY3IDFaIiBzdHJva2U9IiMwMDQxMkYiLz4KPHBhdGggZD0iTTEyLjY2NyAxNy41QzE1LjE1MjMgMTcuNSAxNy4xNjcgMTUuNDg1MyAxNy4xNjcgMTNDMTcuMTY3IDEwLjUxNDcgMTUuMTUyMyA4LjUgMTIuNjY3IDguNUMxMC4xODE3IDguNSA4LjE2Njk5IDEwLjUxNDcgOC4xNjY5OSAxM0M4LjE2Njk5IDE1LjQ4NTMgMTAuMTgxNyAxNy41IDEyLjY2NyAxNy41WiIgc3Ryb2tlPSIjMDA0MTJGIi8+CjxwYXRoIGQ9Ik0xOS40MTcgNi4yNVY2LjI1MSIgc3Ryb2tlPSIjMDA0MTJGIi8+Cjwvc3ZnPgo=";